import email from './email-reducer';
import * as emailOperations from './email-operations';

export { emailOperations };

export default email;